<template>
  <div class="page">
    <!-- <div class="section">
      <h1 class="h2">Impressum / Anbieterkennzeichnung</h1>
      <p>
        <b>Stadtgeschichtliches Museum der Hansestadt Wismar SCHABBELL</b> <br>
        Schweinsbrücke 6/8 <br>
        23966 Wismar <br>
      </p>
      <p>
        <a href="https://www.wismar.de/Rathaus-Politik/Stadtverwaltung/Verwaltungsstruktur/index.php?ModID=9&object=tx%7C2634.1&FID=125.352.1&NavID=2634.38&La=1" target="_blank">Frau Schubert</a>
      </p>
      <p>Inhaltlich verantwortlich für diese Website ist die Hansestadt Wismar: <a href="https://www.wismar.de/Quicknavigation/Impressum" target="_blank">Impressum</a> | <a href="https://www.wismar.de/Quicknavigation/Datenschutz" target="_blank">Datenschutzhinweise</a></p>
    </div> -->
    <div class="section">
      <h1>Impressum</h1>

      <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
      <p><b>Stadtgeschichtliches Museum der Hansestadt Wismar SCHABBELL</b>
        <br />Schweinsbrücke 6/8
        <br />23966 Wismar
      </p>

      <p><b>Vertreten durch:</b>
        <br />Corinna Schubert (<a href="mailto:CSchubert@wismar.de" target="_blank">CSchubert@wismar.de</a>)
      </p>

        <h2>Kontakt</h2>
      <p><b>Telefon:</b> 03841 2243110
        <br /><b>Telefax:</b> 03841 2243120
        <br /><b>E-Mail:</b> <a href="mailto:museum@wismar.de" target="_blank">museum@wismar.de</a>
      </p>

      <h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
      <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

      <h3>Haftung f&uuml;r Inhalte</h3>
      <p>Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder gespeicherte fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen, die auf eine rechtswidrige T&auml;tigkeit hinweisen.</p>
      <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>

      <h3>Haftung f&uuml;r Links</h3>
      <p>Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
      <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>

      <h3>Urheberrecht</h3>
      <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.</p>
      <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>

      <p>Quelle: <a href="https://www.e-recht24.de">https://www.e-recht24.de</a></p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Imprint',
  props: {
    scenes: {type: Object, default: () => {} },
  },
  data () {
    return {

    }
  },
  watch: {

  },
  mounted() {
    document.title = "Impressum | Schabbell 360";
  },
  created() {

  },
  beforeDestroy() {

  },
  computed: {

  },
  methods: {

  },
}
</script>
